import React, {useState,useContext,useRef,useEffect} from "react";

import { useNavigate  } from "react-router-dom";
import Lang from '../../../lang/translations';
import helpers from "../../../_helpers/helpersFunction";
import PopupGenerico from '../../../popup/popupGenerico';

import GooglePayButton from '@google-pay/button-react';
import Context from '../../../context/context';
import googlePay_functions from "./functions";
import Module3ds_adyen from "../adyen/3ds_module";

const config = require("../../../_helpers/configServizi"); 


export default function GooglePay(props) {

    let navigate = useNavigate();
    const context = useContext(Context)

    const [module3ds, setModule_3ds] = useState();
    const [props_3ds, setProps_3ds] = useState();

    const [environment, setEnvironment] = useState(false);
    
        useEffect(() => {
         const domain = window.location.hostname
         if(domain == "localhost"){
            setEnvironment("TEST")
         }else{
            setEnvironment("PRODUCTION")
         }
        }, []);


        async function sendPaymentDataToBackend (data) {

            const d = new Date();
            const domain = window.location.hostname

            var data_request = {
                country : helpers.getCountry(),
                rateplan : context.rateplanScelto,
                payment_company : config.servizi[domain].payment_company,
                descriptor : config.servizi[window.location.hostname].descriptor,
                payment_system : "googlePay",
                city : localStorage.getItem("city"),
                clickid : localStorage.getItem("trackerId"),
                domain : window.location.hostname,
                email : context.email,
                language: navigator.language,
                screenHeight:window.screen.height,
                screenWidth: window.screen.width,
                timezone:d.getTimezoneOffset(),
                userAgent: navigator.userAgent,
                javaEnabled: true,
                javascriptEnabled: true,
                screenColorDepth: window.screen.colorDepth,
                pacchettone: context.flusso.rateplans?.pacchettone?.id
            }
            
            var data_response = data
    
            const dati = { 
                request:data_request,
                response:data_response
            }

            
            
            const response = await googlePay_functions.sendPaymentDataToBackend(dati)

            console.log("RESPONSE",response)
            
             if(response.status === "ok") {
            
                        if(response.threeDS){
                          //---- PROCEDURA PER 3DS
                          console.log("procedura 3DS",response,response.threeDS)
                          procedura3DS(response)
                          return
                        }else{
                          context.setPageOkEnabled(true)
                          context.setPremiumLevel(data_request.rateplan.premiumLevel)
                          const credMsg = context.creditiMessaggi + data_request.rateplan.crediti
                          context.setCreditiMessaggi(credMsg)
                          context.setCustomerId(response.data.customerId)
                          context.setValoreMessaggio(context.flusso.valoreMessaggio)
                          context.setActonfile(true)
                          context.setNewCard(false)
                          //ReactGA.pageview('/ok', 'Charge OK');
                          navigate('/ok/')
                        }
              } else{
                
                if(response.threeDS){
                  //---- PROCEDURA PER 3DS
                  console.log("procedura 3DS",response,response.threeDS)
                  procedura3DS(response)
                  return
                }

                const contenuto = helpers.contenuto_popop_pagamento(response.message)
                
                //setDisabled(false)
                helpers.showPopupgenerico("blocked",context,contenuto)
              
                //ReactGA.pageview('/ko', response.error);
              }
        };


        function procedura3DS(res){
          console.log("ATTIVO PROCEDURA 3DS",res)
          setModule_3ds(res.payment_system)
          setProps_3ds(res)
  
      }

      if(config.servizi[window.location.hostname].google_pay){
        return (<><GooglePayButton
          buttonType="plain"
          environment={config.servizi[window.location.hostname].google_pay.environment}
          buttonColor="white"
          buttonSizeMode="fill"
          paymentRequest={{
            apiVersion: 2,
            apiVersionMinor: 0,
            allowedPaymentMethods: [
              {
                type: 'CARD',
                parameters: {
                  allowedAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'],
                  allowedCardNetworks: ['MASTERCARD', 'VISA'],
                },
                tokenizationSpecification: {
                  type: 'PAYMENT_GATEWAY',
                  parameters: {
                    gateway: 'adyen',
                    gatewayMerchantId:config.servizi[window.location.hostname].google_pay.gatewayMerchantId,
                  },
                },
              },
            ],
            merchantInfo: {
              merchantId: config.servizi[window.location.hostname].google_pay.merchantId,
              merchantName: config.servizi[window.location.hostname].google_pay.merchantName,
            },
            transactionInfo: {
              totalPriceStatus: 'FINAL',
              totalPriceLabel: 'Total',
              totalPrice: context.rateplanScelto.prezzo_totale,
              currencyCode: config.servizi[window.location.hostname].google_pay.valuta,
              countryCode: config.servizi[window.location.hostname].google_pay.country,
            },
          }}
          onLoadPaymentData={(data) => {sendPaymentDataToBackend(data)}}
        />
          {module3ds == "googlePay" && (<><Module3ds_adyen {...props_3ds}/></>)}
        </>
      );
      }else{
        return (<></>)
      }
       

  
}